<template>
  <tr>
    <td>
      <sui-button
        v-for="action in actionList"
        v-bind:content="action"
        v-on:click="buttonAction(action)"
        v-bind:key="action"
      />
    </td>
    <td>{{ teacher.userName }}</td>
    <td v-if="showRole">
      {{
        teacher.role === 'TeacherAdministrator'
          ? 'Teacher administrator'
          : 'Teacher'
      }}
    </td>
    <td v-if="teacher.lastSignInDate">
      {{ teacher.lastSignInDate | moment('DD-MM-YYYY') }}
    </td>
    <td v-if="!teacher.lastSignInDate">not signed in yet</td>
    <td v-if="showRollNumber">{{ teacher.rollNumber }}</td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TeacherTableRow',
  props: ['teacher', 'actions', 'showRollNumber', 'showRole'],
  computed: {
    actionList() {
      if (this.user.profile.role !== 'Administrator' && this.actions) {
        // eslint-disable-next-line arrow-parens
        return this.actions.filter((action) => action !== 'Update');
      }
      return this.actions || [];
    },
    ...mapGetters({
      user: 'user',
    }),
  },
  methods: {
    buttonAction(value) {
      this.$emit('action', { action: value, id: this.teacher.id });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/teachers/TeacherTableRow.vue